// ------------------------------------
// props 輸入需求 : 
// props.toggleDropdown : boolean       (react usestate)
// props.closeToggle : function( void )         ( setToggleDropdown false )
// props.index : int        (外層component 中第幾個 dropdown 沒有就設 0)
// 
// props.data.id : str      ( dropdown 名稱 (or 預設值))
// props.data.keys : array      ( dropdown 真正的選擇內容 )
// props.returndata : function( params: str )       ( 帶入選取值 string )
// ------------------------------------

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import '../../dropdown/_dropdown_toggle.scss';


const DropdownAdmin = (props) => {
    const { t } = useTranslation();
    const [dropdown, setDropdown] = useState(false);
    function toggleDropdown() { setDropdown(!dropdown) }

    const translatedId = props.data.id === "全部單位" ? t("GLOBAL.BED_STATE.ALL") : props.data.id;
    const translatedKeys = props.data.keys?.map((key, index) =>
        index === 0 && key === "全部單位" ? t("GLOBAL.BED_STATE.ALL") : key
    );

    return (
        <div className="wrap-dropdown">
            <div className={`dropdown ${props.closeToggle ? 'active' : ''}`}
                onClick={toggleDropdown}
                onMouseLeave={(dropdown) ? toggleDropdown : null}
            >
                <div className="fx-d-r">
                    <div className="w-30 fx-ccc">
                        <div className={`tri ${dropdown ? 'rotate' : ''}`}></div>
                    </div>
                    <div className="dropdown_header">
                        <div className="fx-ccc min-h-9"
                            data-index={props.index}
                            data-group="dropdown">
                            {translatedId}
                        </div>
                        <div className="line"></div>
                    </div>
                </div>

                <div className="fx-d-c fx-nnfe">
                    <div className={`dropdown_body ${dropdown ? 'active' : 'none'}`}>
                        <div className="div_display">
                            {
                                translatedKeys && translatedKeys.length > 0 && translatedKeys.map((dcg, index) =>
                                    <ul id={`${props.data.id}-${index}`}
                                        key={`${props.data.id}-${index}`}
                                        onClick={() => { props.returnData(props.data.keys[index]) }}
                                    >
                                        <li>
                                            <div className={`dropdown-item `}
                                                id={`${props.data.id}-item_${props.toggle_index}-${index}`}
                                                key={`${props.data.id}-item_${props.toggle_index}-${index}`}
                                            >{dcg}</div>
                                        </li>
                                    </ul>
                                )
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default DropdownAdmin;